import { SearchContentListQueries, SearchCourseListQueries } from "@platformx/authoring-apis";

/**
 * Chooses the correct listing GraphQL query.
 *
 * The base FETCH_CONTENT_TYPE_LIST query does NOT declare
 * $sortOptions: authoring_SortOptions, so it keeps validating on gateways that
 * have not yet deployed. Only when the user explicitly selects a sort that
 * populates `sortOptions` do we switch to FETCH_CONTENT_TYPE_LIST_WITH_SORT,
 * the variant that references the newer type. This decouples this frontend from
 * the backend's promotion order: default / Newest / Oldest listings can never
 * regress on an environment whose backend has not caught up.
 *
 * @param isCourse         Course uses a different query entirely.
 * @param hasSortOptions   True whenever the resolved sort carries `sortOptions`.
 */
export const pickContentListQuery = (isCourse: boolean, hasSortOptions: boolean) => {
  if (isCourse) {
    return SearchCourseListQueries.FETCH_COURSE_LIST;
  }
  if (hasSortOptions) {
    return SearchContentListQueries.FETCH_CONTENT_TYPE_LIST_WITH_SORT;
  }
  return SearchContentListQueries.FETCH_CONTENT_TYPE_LIST;
};
